import { u } from 'unist-builder';
import { StructuredTextDocument } from 'react-datocms'
import { render } from 'datocms-structured-text-to-plain-text'
import { CellStructuredTextEditing } from 'src/types';

export const plainToStructureText = ({ value, isBold, isItalic }: Partial<CellStructuredTextEditing>): StructuredTextDocument => {
  const marks: string[] = []
  if (isBold) marks.push('strong')
  if (isItalic) marks.push('emphasis')

  return {
    schema: 'dast',
    document: u('root', [
      u('paragraph', [
        u('span', { marks }, value!),
      ]),
    ]),
  }
}

export const structuredTextToPlain = (structuredText: StructuredTextDocument) => {
  // The datocms-structured-text-to-plain-text render function ignores the \n so we lose the line breaks
  // To fix this issue we try getting the span value manually
  return (structuredText.document.children[0] as any)?.children[0]?.value ?? render(structuredText) ?? '';
}
